import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuid from 'uuid/v4';
import QuadChart from '../common/Charts/QuadChart';

const chartColor = [
  '#247BA0',
  '#F25F5C',
  '#FFE066',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

class QuadChartViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      horizontalDropdown: 0,
      verticalDropdown: 0,
      horizontalDropdownName: 'Total',
      verticalDropdownName: 'Total',
      chartData: this.renderData(0, 0),
      maxChartPoint: 200,
    };
  }

  UNSAFE_componentWillMount() {
    const thirdHeader = this.getActiveCrosstab()[0].columnHeaderList.filter(
      (header, index) => index === 2 && header,
    );
    const secondHeader = this.getActiveCrosstab()[0].columnHeaderList.filter(
      (header, index) => index === 1 && header,
    );
    this.setState(
      {
        horizontalDropdown: 1,
        horizontalDropdownName: secondHeader[0].label.replace(/\s\s+/g, ' '),
        verticalDropdown: 2,
        verticalDropdownName: thirdHeader[0].label.replace(/\s\s+/g, ' '),
      },
      () =>
        this.setState(
          {
            chartData: this.renderData(
              this.state.horizontalDropdown,
              this.state.verticalDropdown,
            ),
          },
          () => {
            const arrdata = [];
            this.state.chartData.forEach(item => {
              arrdata.push(item.x, item.y);
            });
            this.setState({ maxChartPoint: Math.max(...arrdata) });
          },
        ),
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.crosstabTableList && nextProps.crosstabTableList
      !== this.props.crosstabTableList) {
      const chartData = this.renderData(
          this.state.horizontalDropdown,
          this.state.verticalDropdown,
          nextProps.crosstabTableList,
        );
      this.setState({ chartData }, () => {
        const arrdata = [];
        this.state.chartData.forEach(item => {
          arrdata.push(item.x, item.y);
        });
        this.setState({ maxChartPoint: Math.max(...arrdata) });
      });
    }
  }

  getActiveCrosstab = () =>
    this.props.crosstabTableList.filter(crosstab => crosstab.isActive && crosstab);

  handleHorizontalDropdown = event =>
    this.setState(
      {
        horizontalDropdown: event.target.selectedIndex + 1,
        horizontalDropdownName: event.target.value,
      },
      () =>
        this.setState(
          {
            chartData: this.renderData(
              this.state.horizontalDropdown,
              this.state.verticalDropdown,
            ),
          },
          () => {
            const arrdata = [];
            this.state.chartData.forEach(item => {
              arrdata.push(item.x, item.y);
            });
            this.setState({ maxChartPoint: Math.max(...arrdata) });
          },
        ),
    );

  handleVerticalDropdown = event =>
    this.setState(
      {
        verticalDropdown: event.target.selectedIndex + 1,
        verticalDropdownName: event.target.value,
      },
      () =>
        this.setState(
          {
            chartData: this.renderData(
              this.state.horizontalDropdown,
              this.state.verticalDropdown,
            ),
          },
          () => {
            const arrdata = [];
            this.state.chartData.forEach(item => {
              arrdata.push(item.x, item.y);
            });
            this.setState({ maxChartPoint: Math.max(...arrdata) });
          },
        ),
    );

  renderData = (horizontalDropdown, verticalDropdown, nextPropsData) => {
    let filteredList = [];
    if (nextPropsData) {
      filteredList = nextPropsData.filter(crosstab => crosstab.isActive && crosstab);
    } else {
      filteredList = this.props.crosstabTableList.filter(crosstab => crosstab.isActive && crosstab);
    }

    const rData = filteredList[0]
      .crosstabPerStudy[0][0].rowList.filter(cellRow => cellRow.rowHeader !== 'Total')
      .map((row, index) => ({
        x:
          Number(
            row.cellList[horizontalDropdown].index.replace(
              /[&\/\\#,+()$~%'":*?<>{}]/g,
              '',
            ),
          ) > 0
            ? Number(
                row.cellList[horizontalDropdown].index.replace(
                  /[&\/\\#,+()$~%'":*?<>{}]/g,
                  '',
                ),
              )
            : 0,
        y:
          Number(
            row.cellList[verticalDropdown].index.replace(
              /[&\/\\#,+()$~%'":*?<>{}]/g,
              '',
            ),
          ) > 0
            ? Number(
                row.cellList[verticalDropdown].index.replace(
                  /[&\/\\#,+()$~%'":*?<>{}]/g,
                  '',
                ),
              )
            : 0,
        z: 1,
        name: row.rowHeader,
        rowIndex: index,
      }));
    return rData;
  };

  renderDropdown = () =>
    this.getActiveCrosstab()[0]
      .columnHeaderList.filter(header => header.label !== 'Total')
      .map(header =>
        <option
          key={uuid()}
          title={header.tooltipVal ? header.tooltipVal : header.label}
        >{header.label}</option>);

  render() {
    const { verticalDropdownName, horizontalDropdownName } = this.state;
    const vdName = verticalDropdownName.trim();
    const hdName = horizontalDropdownName.trim();
    return (
      <div>
        <div className="padding-10">
          <div className="row expanded">
            <div className="column large-6">
              <div>
                <label htmlFor="hzlAxis" className="quad-label">Horizontal (X) Axis Column</label>
                <select
                  id="hzlAxis"
                  onChange={this.handleHorizontalDropdown}
                  value={hdName}
                >
                  {this.renderDropdown()}
                </select>
              </div>
            </div>
            <div className="column large-6">
              <div>
                <label htmlFor="verAxis" className="quad-label">Vertical (Y) Axis Column</label>
                <select
                  id="verAxis"
                  onChange={this.handleVerticalDropdown}
                  value={vdName}
                >
                  {this.renderDropdown()}
                </select>
              </div>
            </div>
          </div>
          <div className="row expanded">
            <div className="column medium-12 large-12">
              <QuadChart
                chartColor={chartColor}
                xAxisLine={[
                  {
                    color: 'black',
                    width: 1,
                    value: 100,
                    zIndex: 3,
                  },
                ]}
                yAxisLine={[
                  {
                    color: 'black',
                    width: 1,
                    value: 100,
                    zIndex: 3,
                  },
                ]}
                minMaxTick={{
                  min: 0,
                  max:
                    this.state.maxChartPoint <= 200
                      ? 200
                      : this.state.maxChartPoint + 20,
                  tickInterval: 20,
                }}
                data={this.state.chartData}
                xAxisName={this.state.horizontalDropdownName}
                yAxisName={this.state.verticalDropdownName}
                dataLabelFormatter={function () {
                  return `<div class="incr-reach-custom-legend">${this.point.name.substring(
                    0,
                    10,
                  )}...</div>`;
                }}
              />
            </div>
          </div>
          <p className="text-right">
            {this.props.study}{' '}
            {`(${this.props.weightType.wn})`}
          </p>
        </div>
      </div>
    );
  }
}

QuadChartViewer.propTypes = {
  crosstabTableList: PropTypes.arrayOf(PropTypes.shape({})),
  study: PropTypes.string,
  weightType: PropTypes.shape({
    wn: PropTypes.string,
  }),
};

function mapStateToProps(state) {
  return {
    crosstabTableList: state.crosstab.crosstabTableList,
  };
}

export default connect(mapStateToProps)(QuadChartViewer);
